import _ from 'lodash';

export default function selector(storeState) {
    const organization = _.get(storeState, 'mediaPlanForm.organization');
    return {
        organization,
    };
}
